<template lang="pug">
   app-layout
        template(slot="content")
            app-account
</template>

<script>
//Components
import Account from '@/components/views/account'
import Layout from '@/components/layouts';

export default {
    name: "account",
    components: {
        'app-account': Account,
        'app-layout': Layout,
    },
}
</script>